import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Input, Label, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { jsPDF as JsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { storeDefectManagement } from '../store/page/boggie/boggieThunk';
import { getStageNumbers, fetchAllMakes, getListDefectManagement, getStaticLoadDefectTest } from '../store/page/material/materialThunk';
import ComponentCard from './ComponentCard';
import { hasPermission } from '../utils/permissionUtils';

const styles = `
  .form-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  }
  .form-label {
    font-weight: 600;
    color: #1e293b;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }
  .form-label .required {
    color: #dc3545;
    margin-left: 2px;
  }
  .form-control-custom {
    border-radius: 8px;
    border: 2px solid #e2e8f0;
    padding: 0.6rem 1rem;
    transition: all 0.2s ease;
    font-size: 0.875rem;
  }
  .form-control-custom:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  .form-control-custom.is-invalid {
    border-color: #dc3545;
  }
  .form-control-custom.is-invalid:focus {
    box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
  }
  .btn-submit {
    background: #002D72;
    color: white;
    border: none;
    padding: 10px 32px;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s ease;
  }
  .btn-submit:hover {
    background: #001f4f;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 45, 114, 0.3);
  }
  .btn-submit:disabled {
    background: #93a3b8;
    cursor: not-allowed;
    transform: none;
  }
  .btn-reset {
    background: #f1f5f9;
    color: #475569;
    border: none;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s ease;
  }
  .btn-reset:hover {
    background: #e2e8f0;
  }
  .btn-add-new {
    background: #22c55e;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
  }
  .btn-add-new:hover {
    background: #115a2c;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
  }
  .btn-edit {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 4px 16px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .btn-edit:hover {
    background: #2563eb;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  }
  .preview-section {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 16px;
    margin-top: 20px;
  }
  .preview-label {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .preview-value {
    font-size: 13px;
    color: #1e293b;
    font-weight: 500;
  }
  .dynamic-field {
    animation: slideDown 0.3s ease;
  }
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .dash-section {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
  }
  .dash-title {
    font-size: 16px;
    font-weight: 700;
    color: #002D72;
    margin-bottom: 12px;
    text-align: center;
  }
  .stats-table {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
  }
  .stats-table th {
    background: #f8fafc;
    color: #1e293b;
    font-weight: 600;
    font-size: 12px;
    padding: 10px 12px;
    border-bottom: 2px solid #e2e8f0;
  }
  .stats-table td {
    padding: 10px 12px;
    font-size: 13px;
    border-bottom: 1px solid #e2e8f0;
  }
  .stats-table .total-row {
    background: #f8fafc;
    font-weight: 600;
  }
  .bogie-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0;
    margin: 0;
  }
  .bogie-item {
    background: #f1f5f9;
    padding: 6px 14px;
    border-radius: 12px;
    font-size: 14px;
    color: #1e293b;
    border: 1px solid #e2e8f0;
    font-weight: 500;
  }
  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #e2e8f0;
  }
  .header-title {
    margin: 0;
    color: #002D72;
    font-weight: 700;
    font-size: 20px;
  }
  .sub-title {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
    font-weight: 400;
  }
  .full-width-container {
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
  }
  .defect-table-header {
    background: #f1f5f9 !important;
    color: #1e293b !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    padding: 10px 12px !important;
    text-align: center !important;
  }
  .defect-title {
    font-size: 18px;
    font-weight: 700;
    color: #002D72;
    margin-bottom: 12px;
    text-align: center;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .api-response {
    background: #f8fafc;
    padding: 12px;
    border-radius: 6px;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    overflow-x: auto;
    border: 1px solid #e2e8f0;
    margin-top: 10px;
  }
  .api-response pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .response-success {
    border-left: 4px solid #22c55e;
    background: #f0fdf4;
  }
  .response-error {
    border-left: 4px solid #dc2626;
    background: #fef2f2;
  }
  .response-loading {
    border-left: 4px solid #3b82f6;
    background: #eff6ff;
  }
  .action-cell {
    display: flex;
    gap: 4px;
    justify-content: center;
    align-items: center;
  }
  .modal-header-add {
    background: #1c2b22 !important;
    color: white !important;
  }
  .modal-header-edit {
    background: #1c2b22 !important;
    color: white !important;
  }
  .btn-pdf {
    background: #dc3545;
    color: white;
    border: none;
    padding: 6px 16px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }
  .btn-pdf:hover {
    background: #b02a37;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  }
  .btn-excel {
    background: #28a745;
    color: white;
    border: none;
    padding: 6px 16px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }
  .btn-excel:hover {
    background: #1e7e34;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  }
`;

const AddDefectForm = ({ onSuccess }) => {
    const dispatch = useDispatch();

    // Redux state for list
    const { data: defectList = [], loading: listLoading } = useSelector(
        (state) => state?.ufDimensionallyObsReducer?.getListDefectMngmnt || { data: [], loading: false }
    );

    const { data: staticLoadData = {} } = useSelector(
        (state) => state?.ufDimensionallyObsReducer?.getStaticLoadDft || { data: {}, loading: false }
    );

    const { loading: reduxLoading, error: reduxError } = useSelector(
        (state) => state.ufDimensionallyObsReducer?.defectManagement || { loading: false, error: null, data: null, success: false }
    );

    // Form state
    const [formData, setFormData] = useState({
        date: '',
        componentType: '',
        componentValue: '',
        defect: '',
        firm: '',
        actionTaken: '',
        remarks: ''
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [isComponentChoosed, setIsComponentChoosed] = useState(false);
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [filteredDefects, setFilteredDefects] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const stageNumbers = useSelector((state) => state.ufDimensionallyObsReducer?.stageNumbers?.data || []);
    const loading = useSelector((state) => state.ufDimensionallyObsReducer?.stageNumbers?.loading || false);
    const allMakes = useSelector((state) => state?.ufDimensionallyObsReducer?.all_makes || []);
    const permissions = JSON.parse(localStorage.getItem('permissions')) || [];

    // Fetch defect list
    const fetchDefectList = () => {
        dispatch(getListDefectManagement({ per_page: 100 }));
    };

    // Fetch static load test data
    const fetchStaticLoadData = (params = {}) => {
        dispatch(getStaticLoadDefectTest(params));
    };

    // Fetch data on mount
    useEffect(() => {
        dispatch(fetchAllMakes());
        fetchDefectList();
        fetchStaticLoadData();
    }, []);

    // Refetch static load data when date or month changes
    useEffect(() => {
        const params = {};
        if (dateFrom) {
            params.date_from = dateFrom;
        }
        if (dateTo) {
            params.date_to = dateTo;
        }
        fetchStaticLoadData(params);
    }, [dateFrom, dateTo]);

    useEffect(() => {
        let filtered = defectList;
        if (dateFrom) {
            filtered = filtered.filter(item => item.date >= dateFrom);
        }
        if (dateTo) {
            filtered = filtered.filter(item => item.date <= dateTo);
        }
        setFilteredDefects(filtered);
    }, [dateFrom, dateTo, defectList]);

    useEffect(() => {
        if (formData.componentType) {
            dispatch(getStageNumbers({ stage_type: formData.componentType }));
        }
    }, [formData.componentType, dispatch]);

    // Extract component type from label
    const getComponentTypeFromLabel = (label) => {
        if (!label) return '';
        if (label.includes('Bogie No.')) return 'bogie';
        if (label.includes('Bolster No.')) return 'bolster';
        if (label.includes('Bogie Frame No.')) return 'bogieFrame';
        if (label.includes('Side-Frame No.')) return 'sideFrame';
        if (label.includes('Break-Beam No.')) return 'breakBeam';
        return '';
    };

    const extractComponentValue = (label) => {
        if (!label) return '';
        const parts = label.split(' ');
        return parts[parts.length - 1] || '';
    };

    const resetForm = () => {
        setFormData({
            date: '',
            componentType: '',
            componentValue: '',
            defect: '',
            firm: '',
            actionTaken: '',
            remarks: ''
        });
        setErrors({});
        setSubmitStatus(null);
        setIsComponentChoosed(false);
    };

    const resetAllStates = () => {
        resetForm();
        setIsEditMode(false);
        setEditingId(null);
        setIsSubmitting(false);
        setSubmitStatus(null);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "componentType") {
            if (value) {
                setIsComponentChoosed(true);
                setFormData({
                    ...formData,
                    componentType: value,
                    componentValue: ''
                });
            } else {
                setIsComponentChoosed(false);
                setFormData({
                    ...formData,
                    componentType: '',
                    componentValue: ''
                });
            }
        } else if (name === "firm") {
            const selectedFirm = allMakes.find(item => item.id === value);
            setFormData({
                ...formData,
                firm: selectedFirm ? selectedFirm.title : value
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ''
            });
        }
        if (submitStatus) {
            setSubmitStatus(null);
        }
    };

    // ============ ADD MODAL HANDLERS ============
    const toggleAddModal = () => {
        setAddModalOpen(!addModalOpen);
        if (!addModalOpen) {
            resetAllStates();
        }
    };

    const handleAddNew = () => {
        resetAllStates();
        setAddModalOpen(true);
    };

    // ============ EDIT MODAL HANDLERS ============
    const toggleEditModal = () => {
        setEditModalOpen(!editModalOpen);
        if (!editModalOpen) {
            resetAllStates();
        }
    };

    const handleEdit = (item) => {
        const componentType = item.component_type || getComponentTypeFromLabel(item.components);
        const componentValue = item.component_value || extractComponentValue(item.components);

        setFormData({
            date: item.date || new Date().toISOString().split('T')[0],
            componentType,
            componentValue,
            defect: item.defect || '',
            firm: item.firm || '',
            actionTaken: item.action_taken || 'Rectified by Production staff',
            remarks: item.remarks || 'Satisfactory'
        });

        if (componentType) {
            setIsComponentChoosed(true);
            dispatch(getStageNumbers({ stage_type: componentType }));
        }

        setEditingId(item.id);
        setIsEditMode(true);
        setErrors({});
        setSubmitStatus(null);
        setEditModalOpen(true);
    };

    // ============ FORM SUBMISSION ============
    const handleModalSubmit = async () => {
        const newErrors = {};
        if (!formData.date) newErrors.date = 'Please select a date';
        if (!formData.componentType) newErrors.componentType = 'Please select a component type';
        if (!formData.componentValue) newErrors.componentValue = 'Please select a component value';
        if (!formData.defect || formData.defect.trim() === '') newErrors.defect = 'Please enter the defect description';
        if (!formData.firm) newErrors.firm = 'Please select a firm';
        if (!formData.actionTaken || formData.actionTaken.trim() === '') newErrors.actionTaken = 'Please enter the action taken';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            toast.error('Please fill all required fields');
            return;
        }

        setIsSubmitting(true);
        setSubmitStatus('loading');

        try {
            const payload = {
                date: formData.date,
                component_type: formData.componentType,
                component_value: formData.componentValue,
                defect: formData.defect,
                firm: formData.firm,
                action_taken: formData.actionTaken,
                remarks: formData.remarks || 'Satisfactory',
            };

            if (isEditMode && editingId) {
                payload.id = editingId;
                const result = await dispatch(storeDefectManagement(payload)).unwrap();
                setSubmitStatus('success');
                toast.success(result?.message || 'Defect updated successfully!');
                setTimeout(() => {
                    resetAllStates();
                    setEditModalOpen(false);
                    fetchDefectList();
                    fetchStaticLoadData();
                }, 1000);
            } else {
                const result = await dispatch(storeDefectManagement(payload)).unwrap();
                setSubmitStatus('success');
                toast.success(result?.message || 'Defect added successfully!');
                setTimeout(() => {
                    resetAllStates();
                    setAddModalOpen(false);
                    fetchDefectList();
                    fetchStaticLoadData();
                }, 1000);
            }

            if (onSuccess) onSuccess(payload);

        } catch (error) {
            console.error('❌ Submission error:', error);
            setSubmitStatus('error');
            toast.error(typeof error === 'string' ? error : 'Failed to save defect. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const getComponentLabel = () => {
        const types = {
            bogie: 'Bogie No.',
            bolster: 'Bolster No.',
            bogieFrame: 'Bogie Frame No.',
            sideFrame: 'Side-Frame No.',
            breakBeam: 'Break-Beam No.'
        };
        return types[formData.componentType] || 'Component';
    };

    const componentTypes = [
        { value: 'bogie', label: 'Bogie No.' },
        { value: 'bolster', label: 'Bolster No.' },
        { value: 'bogieFrame', label: 'Bogie Frame No.' },
        { value: 'sideFrame', label: 'Side-Frame No.' },
        { value: 'breakBeam', label: 'Break-Beam No.' }
    ];

    const getComponentOptions = () => {
        const numbers = Array.isArray(stageNumbers) ? stageNumbers : [];
        return [
            { value: '', label: `Select ${getComponentLabel()}` },
            ...numbers.map(item => ({
                value: item.value || item,
                label: item.label || item.value || item
            }))
        ];
    };

    // ============ MODAL FORM CONTENT ============
    const modalFormContent = (
        <form>
            <Row className="mb-3">
                <Col md={4}>
                    <FormGroup>
                        <Label className="form-label">Date <span className="required">*</span></Label>
                        <Input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                            disabled={isSubmitting || reduxLoading}
                            className={`form-control-custom ${errors.date ? 'is-invalid' : ''}`}
                        />
                        {errors.date && <div className="text-danger mt-1" style={{ fontSize: '0.85rem' }}>{errors.date}</div>}
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="form-label">Component Type <span className="required">*</span></Label>
                        <select
                            name="componentType"
                            value={formData.componentType}
                            onChange={handleChange}
                            disabled={isSubmitting || reduxLoading}
                            className={`form-control-custom form-select ${errors.componentType ? 'is-invalid' : ''}`}
                            style={{ width: '100%' }}
                        >
                            <option value="">Select Component Type</option>
                            {componentTypes.map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                        {errors.componentType && <div className="text-danger mt-1">{errors.componentType}</div>}
                    </FormGroup>
                </Col>
                {isComponentChoosed && (
                    <Col md={4}>
                        <FormGroup>
                            <Label className="form-label">{getComponentLabel()} <span className="required">*</span></Label>
                            <select
                                name="componentValue"
                                value={formData.componentValue}
                                onChange={handleChange}
                                disabled={isSubmitting || loading}
                                className={`form-control-custom form-select ${errors.componentValue ? 'is-invalid' : ''}`}
                                style={{ width: '100%' }}
                            >
                                {getComponentOptions().map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                            {errors.componentValue && <div className="text-danger mt-1">{errors.componentValue}</div>}
                        </FormGroup>
                    </Col>
                )}
            </Row>

            <Row className="mb-3">
                <Col md={4}>
                    <FormGroup>
                        <Label className="form-label">Defect <span className="required">*</span></Label>
                        <Input
                            type="text"
                            name="defect"
                            value={formData.defect}
                            onChange={handleChange}
                            disabled={isSubmitting || reduxLoading}
                            placeholder="Enter defect description"
                            className={`form-control-custom ${errors.defect ? 'is-invalid' : ''}`}
                        />
                        {errors.defect && <div className="text-danger mt-1">{errors.defect}</div>}
                    </FormGroup>
                </Col>
                <Col lg={4}>
                    <FormGroup>
                        <Label className="form-label">Firm <span className="text-danger">*</span></Label>
                        <select
                            name="firm"
                            value={allMakes.find(item => item.title === formData.firm)?.id || ''}
                            onChange={handleChange}
                            className={`form-control-custom form-select ${errors.firm ? 'is-invalid' : ''}`}
                            style={{ width: '100%' }}
                        >
                            <option value="">Select Firm</option>
                            {allMakes
                                ?.filter((item) => item.metal_type && item.metal_type.includes('bogie'))
                                ?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.title}
                                    </option>
                                ))
                            }
                        </select>
                        {errors.firm && <div className="text-danger mt-1">{errors.firm}</div>}
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="form-label">Action Taken <span className="required">*</span></Label>
                        <Input
                            type="text"
                            name="actionTaken"
                            value={formData.actionTaken}
                            onChange={handleChange}
                            disabled={isSubmitting || reduxLoading}
                            placeholder="Enter action taken"
                            className={`form-control-custom ${errors.actionTaken ? 'is-invalid' : ''}`}
                        />
                        {errors.actionTaken && <div className="text-danger mt-1">{errors.actionTaken}</div>}
                    </FormGroup>
                </Col>
            </Row>

            <Row className="mb-4">
                <Col md={12}>
                    <FormGroup>
                        <Label className="form-label">Remarks</Label>
                        <Input
                            type="text"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                            disabled={isSubmitting || reduxLoading}
                            placeholder="Enter remarks"
                            className="form-control-custom"
                        />
                    </FormGroup>
                </Col>
            </Row>
        </form>
    );

    const verifiedBy = staticLoadData?.verified_by || [];
    const loadTestedBogies = staticLoadData?.load_tested_bogie_numbers || [];

    // ============ EXPORT FUNCTIONS ============
    const exportToPDF = async () => {
        try {
            if (!filteredDefects || filteredDefects.length === 0) {
                alert('No data to export');
                return;
            }

            const doc = new JsPDF('landscape', 'mm', 'a4');
            const now = new Date();
            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();
            const formattedDateTime = `${day}/${month}/${year}`;

            // Title
            doc.setFontSize(16);
            doc.text('Bogie Position Report', 14, 15);
            doc.setFontSize(10);
            doc.text(`Generated: ${formattedDateTime}`, 14, 22);
            doc.text(`Total Records: ${filteredDefects.length}`, 14, 28);

            let currentY = 35;

            // ============ STATIC LOAD TEST POSITION SECTION ============
            doc.setFontSize(12);
            doc.text('STATIC LOAD TEST POSITION', 14, currentY);
            currentY += 5;

            // Static Load Test Table
            const staticLoadRows = verifiedBy.map(item => [
                item.name || '',
                item.today || 0,
                item.monthly || 0,
                item.cumulative || 0
            ]);

            staticLoadRows.push([
                'Load tested Bogie No.',
                loadTestedBogies.join(', ') || '',
                '',
                ''
            ]);

            autoTable(doc, {
                head: [['Verified by', 'Today', 'Monthly', 'Cumulative (April-26 to till date)']],
                body: staticLoadRows,
                startY: currentY,
                styles: {
                    fontSize: 7,
                    cellPadding: 2
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: [255, 255, 255],
                    fontSize: 7,
                    fontStyle: 'bold'
                },
                alternateRowStyles: {
                    fillColor: [240, 240, 240]
                },
                margin: { top: 10, bottom: 10, left: 8, right: 8 },
                tableWidth: 'auto',
            });

            currentY = doc.lastAutoTable.finalY + 10;

            // ============ DETAILED DATA TABLE ============
            doc.setFontSize(12);
            doc.text('Daily Notable Bogie related Defects', 14, currentY);
            currentY += 5;

            const columns = [
                'Sr. No.', 'Components', 'Defects', 'Firm', 
                'Action Taken', 'Remarks', 'Date'
            ];

            const rows = filteredDefects.map((item, index) => {
                const componentLabel = item.component_type
                    ? `${componentTypes.find(c => c.value === item.component_type)?.label || ''} ${item.component_value || ''}`.trim()
                    : item.components || '-';
                return [
                    index + 1,
                    componentLabel,
                    item.defect || '-',
                    item.firm || '-',
                    item.action_taken || '-',
                    item.remarks || '-',
                    item.formatted_date || '-'
                ];
            });

            autoTable(doc, {
                head: [columns],
                body: rows,
                startY: currentY,
                styles: {
                    fontSize: 7,
                    cellPadding: 1.5
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: [255, 255, 255],
                    fontSize: 7,
                    fontStyle: 'bold'
                },
                alternateRowStyles: {
                    fillColor: [240, 240, 240]
                },
                margin: { top: 10, bottom: 10, left: 6, right: 6 },
                pageBreak: 'auto',
                tableWidth: 'auto',
            });

            const totalPages = doc.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.setFontSize(8);
                doc.text(
                    `Page ${i} of ${totalPages}`,
                    doc.internal.pageSize.getWidth() - 20,
                    doc.internal.pageSize.getHeight() - 10
                );
                doc.text(
                    `Total: ${filteredDefects.length}`,
                    14,
                    doc.internal.pageSize.getHeight() - 10
                );
            }
            doc.save(`Bogie_Position_Report_${formattedDateTime}.pdf`);
        } catch (error) {
            console.error('Error exporting PDF:', error);
            alert('Failed to export PDF. Please try again.');
        }
    };

    const exportToExcel = async () => {
        try {
            if (!filteredDefects || filteredDefects.length === 0) {
                alert('No data to export');
                return;
            }

            const wb = XLSX.utils.book_new();

            const summaryRows = [
                ['BOGIE POSITION REPORT'],
                [],
                ['STATIC LOAD TEST POSITION'],
                ['Verified by', 'Today', 'Monthly', 'Cumulative (April-26 to till date)']
            ];

            verifiedBy.forEach(item => {
                summaryRows.push([
                    item.name || '',
                    item.today || 0,
                    item.monthly || 0,
                    item.cumulative || 0
                ]);
            });

            summaryRows.push([
                'Load tested Bogie No.',
                loadTestedBogies.join(', ') || '',
                '',
                ''
            ]);

            summaryRows.push([]);
            summaryRows.push([]);

            summaryRows.push(['DAILY NOTABLE BOGIE RELATED DEFECTS']);
            summaryRows.push(['Sr. No.', 'Components', 'Defects', 'Firm', 'Action Taken', 'Remarks', 'Date']);

            filteredDefects.forEach((item, index) => {
                const componentLabel = item.component_type
                    ? `${componentTypes.find(c => c.value === item.component_type)?.label || ''} ${item.component_value || ''}`.trim()
                    : item.components || '-';
                summaryRows.push([
                    index + 1,
                    componentLabel,
                    item.defect || '-',
                    item.firm || '-',
                    item.action_taken || '-',
                    item.remarks || '-',
                    item.formatted_date || '-'
                ]);
            });

            const ws = XLSX.utils.aoa_to_sheet(summaryRows);

            ws['!cols'] = [
                { wch: 12 }, // Sr. No.
                { wch: 25 }, // Components
                { wch: 30 }, // Defects
                { wch: 20 }, // Firm
                { wch: 25 }, // Action Taken
                { wch: 20 }, // Remarks
                { wch: 15 }, // Date
            ];

            XLSX.utils.book_append_sheet(wb, ws, 'Bogie Report');

            const now = new Date();
            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();
            const dateStr = `${day}-${month}-${year}`;
            XLSX.writeFile(wb, `Bogie_Position_Report_${dateStr}.xlsx`);
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to export Excel');
        }
    };

    return (
        <div className="page-wrapper">
            <style>{styles}</style>
            <div className="full-width-container">
                <ComponentCard
                    title={<span style={{ fontWeight: '700' }}>Bogie Position Report</span>}
                    action={
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        {hasPermission(permissions, 'bogie_position_report_create') && (
                            <button
                                type="button"
                                className="btn-add-new"
                                onClick={handleAddNew}
                                disabled={reduxLoading || listLoading}
                                style={{
                                    background: (reduxLoading || listLoading) ? '#93a3b8' : '#1e8644',
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px 20px',
                                    borderRadius: '8px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    whiteSpace: 'nowrap',
                                    cursor: (reduxLoading || listLoading) ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <span style={{ fontSize: '18px', lineHeight: 1, fontWeight: 700 }}>
                                    {(reduxLoading || listLoading) ? '⏳' : '+'}
                                </span>
                                {(reduxLoading || listLoading) ? 'Loading...' : 'Add New'}
                            </button>
                            )}
                            <button
              className="btn btn-danger"
              type="button"
              onClick={exportToPDF}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 16px', borderRadius: '4px', border: 'none' }}
            >
              <i className="bi bi-file-pdf"></i> PDF
            </button>
            <button
              className="btn btn-success"
              type="button"
              onClick={exportToExcel}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 16px', borderRadius: '4px', border: 'none' }}
            >
              <i className="bi bi-file-excel"></i> Excel
            </button>
                        </div>
                    }
                >
                    <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                        <Label style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>Date From:</Label>
                        <input
                            type="date"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                            style={{
                                borderRadius: '6px',
                                border: '1px solid #d1d5db',
                                padding: '6px 12px',
                                fontSize: '14px',
                                background: 'white',
                                color: '#1e293b',
                                outline: 'none',
                                width: '180px'
                            }}
                            placeholder="From Date"
                        />
                        <span style={{ color: '#94a3b8' }}>to</span>
                        <input
                            type="date"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            style={{
                                borderRadius: '6px',
                                border: '1px solid #d1d5db',
                                padding: '6px 12px',
                                fontSize: '14px',
                                background: 'white',
                                color: '#1e293b',
                                outline: 'none',
                                width: '180px'
                            }}
                            placeholder="To Date"
                        />
                        {(dateFrom || dateTo) && (
                            <button
                                type="button"
                                onClick={() => {
                                    setDateFrom('');
                                    setDateTo('');
                                }}
                                style={{
                                    padding: '4px 12px',
                                    background: '#ef4444',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px'
                                }}
                            >
                                Clear
                            </button>
                        )}
                    </div>

                    {/* STATIC LOAD TEST POSITION - Dynamic */}
                    <div className="dash-section" style={{ marginBottom: '20px' }}>
                        <div style={{ marginBottom: '16px' }}>
                            <div className="dash-title" style={{ fontWeight: '800', fontSize: '18px' }}>
                                STATIC LOAD TEST POSITION
                            </div>

                            <Table bordered className="stats-table">
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: '15px', fontWeight: '700', background: '#f8fafc', padding: '12px 12px', borderBottom: '2px solid #e2e8f0', textAlign: 'center' }}>Verified by</th>
                                        <th style={{ fontSize: '15px', fontWeight: '700', background: '#f8fafc', padding: '12px 12px', borderBottom: '2px solid #e2e8f0', textAlign: 'center' }}>Today</th>
                                        <th style={{ fontSize: '15px', fontWeight: '700', background: '#f8fafc', padding: '12px 12px', borderBottom: '2px solid #e2e8f0', textAlign: 'center' }}>Monthly</th>
                                        <th style={{ fontSize: '15px', fontWeight: '700', background: '#f8fafc', padding: '12px 12px', borderBottom: '2px solid #e2e8f0', textAlign: 'center' }}>Cumulative (April-26 to till date)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {verifiedBy.map((item, index) => (
                                        <tr key={`verified-${item.name || index}`} className={item.name === 'TOTAL' ? 'total-row' : ''}>
                                            <td><strong style={{ fontSize: '14px' }}>{item.name}</strong></td>
                                            <td style={{ fontSize: '14px', textAlign: 'center' }}>{item.today || 0}</td>
                                            <td style={{ fontSize: '14px', textAlign: 'center' }}>{item.monthly || 0}</td>
                                            <td style={{ fontSize: '14px', textAlign: 'center' }}>{item.cumulative || 0}</td>
                                        </tr>
                                    ))}
                                    <tr style={{ backgroundColor: '#ffffff' }}>
                                        <td style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b', padding: '10px 12px', verticalAlign: 'middle' }}>
                                            Load tested Bogie No.
                                        </td>
                                        <td colSpan="3" style={{ padding: '10px 12px' }}>
                                            <div className="bogie-list">
                                                {loadTestedBogies.length > 0 ? (
                                                    loadTestedBogies.map((bogie) => (
                                                        <span key={bogie} className="bogie-item">{bogie}</span>
                                                    ))
                                                ) : (
                                                    <span className="text-muted"></span>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>

                    {/* Daily Notable Bogie related Defects - Dynamic */}
                    <div className="dash-section">
                        <div>
                            <div className="defect-title">Daily Notable Bogie related Defects</div>

                            <Table bordered className="stats-table">
                                <thead>
                                    <tr>
                                        <th className="defect-table-header">Sr. No.</th>
                                        <th className="defect-table-header">Components</th>
                                        <th className="defect-table-header">Defects</th>
                                        <th className="defect-table-header">Firm</th>
                                        <th className="defect-table-header">Action Taken</th>
                                        <th className="defect-table-header">Remarks</th>
                                        <th className="defect-table-header">Date</th>
                                        <th className="defect-table-header">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listLoading ? (
                                        <tr>
                                            <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                                <div className="spinner-border text-primary" role="status" style={{ width: '30px', height: '30px' }}>
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <div className="mt-2">Loading defects...</div>
                                            </td>
                                        </tr>
                                    ) : filteredDefects.length > 0 ? (
                                        filteredDefects.map((item, index) => {
                                            const componentLabel = item.component_type
                                                ? `${componentTypes.find(c => c.value === item.component_type)?.label || ''} ${item.component_value || ''}`.trim()
                                                : item.components || '-';
                                            return (
                                                <tr key={item.id || index}>
                                                    <td style={{ textAlign: 'center', fontWeight: '600', fontSize: '14px' }}>{index + 1}</td>
                                                    <td style={{ fontSize: '14px' }}>{componentLabel}</td>
                                                    <td style={{ fontSize: '14px' }}>{item.defect || '-'}</td>
                                                    <td style={{ fontSize: '14px' }}>{item.firm || '-'}</td>
                                                    <td style={{ fontSize: '14px' }}>{item.action_taken || '-'}</td>
                                                    <td style={{ fontSize: '14px' }}>{item.remarks || '-'}</td>
                                                    <td style={{ fontSize: '14px' }}>{item.formatted_date || '-'}</td>
                                                    <td>
                                                        <div className="action-cell">
                                                            {hasPermission(permissions, 'bogie_position_report_edit') && (
                                                            <button
                                                                type="button"
                                                                className="btn-edit"
                                                                onClick={() => handleEdit(item)}
                                                                disabled={reduxLoading || listLoading}
                                                            >
                                                                Edit
                                                            </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="8" style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                                                No data Available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>

                    {/* ============ ADD MODAL ============ */}
                    <Modal isOpen={addModalOpen} toggle={toggleAddModal} size="lg">
                        <ModalHeader toggle={toggleAddModal} className="modal-header-add">
                            <div style={{ textAlign: 'center', width: '100%', fontWeight: 'bold', fontSize: '18px' }}>
                                Add Daily Notable Bogie related Defects
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            {submitStatus === 'success' && !isEditMode && (
                                <div style={{ background: '#d1fae5', border: '1px solid #34d399', color: '#065f46', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ fontSize: '18px' }}>✅</span>
                                    <span>Defect added successfully! Closing modal...</span>
                                </div>
                            )}
                            {submitStatus === 'error' && !isEditMode && (
                                <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', color: '#991b1b', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ fontSize: '18px' }}>❌</span>
                                    <span>{typeof reduxError === 'string' ? reduxError : 'Failed to add defect. Please try again.'}</span>
                                </div>
                            )}
                            {reduxLoading && (
                                <div style={{ background: '#eff6ff', border: '1px solid #3b82f6', color: '#1e40af', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ display: 'inline-block', width: '16px', height: '16px', border: '2px solid #3b82f6', borderTop: '2px solid transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                    <span>Submitting...</span>
                                </div>
                            )}
                            {modalFormContent}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => { resetAllStates(); setAddModalOpen(false); }} disabled={isSubmitting || reduxLoading} style={{ background: '#f1f5f9', border: '1px solid #d1d5db', color: '#475569', minWidth: '80px', padding: '10px 24px', borderRadius: '8px', fontWeight: '600' }}>Cancel</Button>
                            <Button color="primary" onClick={handleModalSubmit} disabled={isSubmitting || reduxLoading} style={{ background: '#101f16', border: 'none', minWidth: '100px', padding: '10px 32px', borderRadius: '8px', fontWeight: '600' }}>
                                {isSubmitting || reduxLoading ? (
                                    <>
                                        <span style={{ display: 'inline-block', width: '16px', height: '16px', border: '2px solid #ffffff', borderTop: '2px solid transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite', marginRight: '8px' }} />
                                        Submitting...
                                    </>
                                ) : 'Submit'}
                            </Button>
                        </ModalFooter>
                    </Modal>

                    {/* ============ EDIT MODAL ============ */}
                    <Modal isOpen={editModalOpen} toggle={toggleEditModal} size="lg">
                        <ModalHeader toggle={toggleEditModal} className="modal-header-edit">
                            <div style={{ textAlign: 'center', width: '100%', fontWeight: 'bold', fontSize: '18px' }}>
                                Edit Daily Notable Bogie related Defects
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            {submitStatus === 'success' && isEditMode && (
                                <div style={{ background: '#d1fae5', border: '1px solid #34d399', color: '#065f46', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ fontSize: '18px' }}>✅</span>
                                    <span>Defect updated successfully! Closing modal...</span>
                                </div>
                            )}
                            {submitStatus === 'error' && isEditMode && (
                                <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', color: '#991b1b', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ fontSize: '18px' }}>❌</span>
                                    <span>{typeof reduxError === 'string' ? reduxError : 'Failed to update defect. Please try again.'}</span>
                                </div>
                            )}
                            {reduxLoading && (
                                <div style={{ background: '#eff6ff', border: '1px solid #3b82f6', color: '#1e40af', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ display: 'inline-block', width: '16px', height: '16px', border: '2px solid #3b82f6', borderTop: '2px solid transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                    <span>Updating...</span>
                                </div>
                            )}
                            {modalFormContent}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => { resetAllStates(); setEditModalOpen(false); }} disabled={isSubmitting || reduxLoading} style={{ background: '#f1f5f9', border: '1px solid #d1d5db', color: '#475569', minWidth: '80px', padding: '10px 24px', borderRadius: '8px', fontWeight: '600' }}>Cancel</Button>
                            <Button color="primary" onClick={handleModalSubmit} disabled={isSubmitting || reduxLoading} style={{ background: '#050b14', border: 'none', minWidth: '100px', padding: '10px 32px', borderRadius: '8px', fontWeight: '600' }}>
                                {isSubmitting || reduxLoading ? (
                                    <>
                                        <span style={{ display: 'inline-block', width: '16px', height: '16px', border: '2px solid #ffffff', borderTop: '2px solid transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite', marginRight: '8px' }} />
                                        Updating...
                                    </>
                                ) : 'Update'}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </ComponentCard>
            </div>
        </div>
    );
};

AddDefectForm.propTypes = {
    onSuccess: PropTypes.func
};

AddDefectForm.defaultProps = {
    onSuccess: null
};

export default AddDefectForm;